<template>
  <div class="agencyCenterListBox">
    <div class="situationList" v-show="agencyOrOver">
      <van-list
        ref="vanList"
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText1"
        :immediate-check="false"
        @load="onLoad"
        class="wrapper"
        >
        <div class="situationListItem" v-for="(item,indx) in todoList" :key="indx">
          <div class="situationTopBox">
            <h4 class="situationTitle">{{item.title}}</h4>
            <div class="situationBtn" @click="topage(item)">立即处理</div>
          </div>
          <ul class="situationDatailList" v-if="item.taskType==1">
            <li>
              <div class="detailTitle">任务名称：</div>
              <div class="situationData">{{item.name}}</div>
            </li>
            <li v-if="item.industryCategory">
              <div class="detailTitle">涉及行业类别：</div>
              <div class="sitData" v-for="(itm,idex) in item.industryCategory" :key="idex">{{itm}}</div>
            </li>
            <li>
              <div class="detailTitle">目标完成时间：</div>
              <div class="situationData" v-show='item.planTime'>{{item.planTime|filtTime}}</div>
            </li>
          </ul>
          <ul class="situationDatailList" v-if="item.taskType==2">
            <li>
              <div class="detailTitle">任务名称：</div>
              <div class="situationData">{{item.name}}</div>
            </li>
            <li v-if="item.industryCategory">
              <div class="detailTitle">审核意见：</div>
              <div class="sitData">{{item.memo}}</div>
            </li>
            <li>
              <div class="detailTitle">审核结果：</div>
              <div class="situationData">{{item.handleResult}}</div>
            </li>
          </ul>
          <ul class="situationDatailList" v-if="item.taskType==3">
            <li>
              <div class="detailTitle">企业名称：</div>
              <div class="situationData">{{item.name}}</div>
              <!-- <div class="Surplus">
                  剩余{{3}}天
              </div> -->
            </li>
            <li>
              <div class="detailTitle">进入重点关注日期：</div>
              <div class="situationData" v-show='item.planTime'>{{item.planTime|filtTime}}</div>
            </li>
          </ul>
          <ul class="situationDatailList" v-if="item.taskType==4">
            <li>
              <div class="detailTitle">企业名称：</div>
              <div class="situationData">{{item.name}}</div>
                <!-- <div class="Surplus">
                  剩余{{3}}天
              </div> -->
            </li>
            <li>
              <div class="detailTitle">所属辖区：</div>
              <div class="situationData">{{item.regionName}}</div>
            </li>
            <li>
              <div class="detailTitle">重点关注期日期：</div>
              <div class="situationData" v-show='item.planTime'>{{item.planTime|filtTime}}</div>
            </li>
          </ul>
          <ul class="situationDatailList" v-if="item.taskType==30 || item.taskType==31 || item.taskType==32 || item.taskType==33">
            <li>
              <div class="detailTitle">企业名称：</div>
              <div class="situationData">{{item.name}}</div>
                <!-- <div class="Surplus">
                  剩余{{3}}天
              </div> -->
            </li>
            <li>
              <div class="detailTitle">进入重点关注时间：</div>
              <div class="situationData" v-show='item.planTime'>{{item.planTime|filtTime}}</div>
            </li>
          </ul>
        </div>
      </van-list>
    </div>
    <div class="overList" v-show="!agencyOrOver">
      <van-list
        ref="vanList"
        v-model="loadingTwo"
        :finished="finishedTwo"
        :finished-text="finishedText2"
        :immediate-check="false"
        @load="onLoadTwo"
        class="wrapper"
        >
        <div
          class="overListItem"
          v-for="(item,index) in finishList"
          :key="index"
          @click="toFinished(item)"
          >
          <div class="overListTopBox">
            <h4 class="overListTitle">{{item.title}}</h4>
            <div class="overListBtn" v-if='item.taskType==1'>已完成</div>
              <div class="overListBtn"  v-else>已知悉</div>
          </div>
          <ul class="overListDatailList" v-if='item.taskType==1'>
            <li>
              <div class="overListDetailTitle">任务名称：</div>
              <div class="overListData">{{item.name}}</div>
            </li>
            <li>
              <div class="overListDetailTitle">审核意见：</div>
              <div class="overListData">{{item.memo}}</div>
            </li>
            <li>
              <div class="overListDetailTitle">审核结果：</div>
              <div class="overListData">{{item.handleResult}}</div>
            </li>
            <li>
              <div class="overListDetailTitle">处理时间：</div>
              <div class="overListData" v-show='item.planTime'>{{item.planTime|filtTime}}</div>
            </li>
            <li>
              <div class="overListDetailTitle">处理人：</div>
              <div class="overListData">{{item.handleName}}</div>
            </li>
          </ul>
          <ul class="overListDatailList" v-if='item.taskType==2'>
            <li>
              <div class="overListDetailTitle">任务名称：</div>
              <div class="overListData">{{item.name}}</div>
            </li>
            <li>
              <div class="overListDetailTitle">审核意见：</div>
              <div class="overListData">{{item.memo}}</div>
            </li>
            <li>
              <div class="overListDetailTitle">审核结果：</div>
              <div class="overListData">{{item.handleResult}}</div>
            </li>
            <li>
              <div class="overListDetailTitle">处理时间：</div>
              <div class="overListData" v-show='item.planTime'>{{item.planTime|filtTime}}</div>
            </li>
            <li>
              <div class="overListDetailTitle">处理人：</div>
              <div class="overListData">{{item.handleName}}</div>
            </li>
          </ul>
           <ul class="overListDatailList" v-if='item.taskType==3'>
            <li>
              <div class="overListDetailTitle">企业名称：</div>
              <div class="overListData">{{item.name}}</div>
            </li>
            <li>
              <div class="overListDetailTitle">所属辖区：</div>
              <div class="overListData">{{item.regionName}}</div>
            </li>
            <li>
              <div class="overListDetailTitle">进入重点关注日期：</div>
              <div class="overListData" v-show='item.planTime'>{{item.planTime|filtTime}}</div>
            </li>
            <li>
              <div class="overListDetailTitle">处理时间：</div>
              <div class="overListData" v-show='item.handleTime'>{{item.handleTime|filtTime}}</div>
            </li>
            <li>
              <div class="overListDetailTitle">处理人：</div>
              <div class="overListData">{{item.handleName}}</div>
            </li>
          </ul>
          <ul class="overListDatailList" v-if='item.taskType==4'>
            <li>
              <div class="overListDetailTitle">企业名称：</div>
              <div class="overListData">{{item.name}}</div>
            </li>
            <li>
              <div class="overListDetailTitle">所属辖区：</div>
              <div class="overListData">{{item.regionName}}</div>
            </li>
            <li>
              <div class="overListDetailTitle">进入重点关注日期：</div>
              <div class="overListData" v-show='item.planTime'>{{item.planTime|filtTime}}</div>
            </li>
            <li>
              <div class="overListDetailTitle">处理时间：</div>
              <div class="overListData" v-show='item.handleTime'>{{item.handleTime|filtTime}}</div>
            </li>
            <li>
              <div class="overListDetailTitle">处理人：</div>
              <div class="overListData">{{item.handleName}}</div>
            </li>
          </ul>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
    import api from '../../../service/modules/integrity';
    export default {
        name: 'AgencyCenterList',
        props: {
            pAgencyOrOver: Boolean
        },
        data () {
            return {
                isImg: 'https://img.yzcdn.cn/vant/logo.png',
                loading: false,
                finished: false,
                loadingTwo: false,
                finishedTwo: false,
                agencyOrOver: true,
                pageIndexTwo: 1,
                pageSizeTwo: 10,
                pageIndex: 1,
                pageSize: 10,
                finishedText1: '', // 待处理的提示
                finishedText2: '', // 已完成的提示
                auditStatus: '', // 审核状态
                todoList: [], // 待处理任务列表
                finishList: [] // 已完成列表
            };
        },
        activated () {
            this.todoList = [] // 待处理任务列表
            this.finishList = []
            this.handleList();
            this.finishedList();
        },
        watch: {
            'pAgencyOrOver' (val) {
                if (val) {
                    this.agencyOrOver = true;
                } else {
                    this.agencyOrOver = false;
                }
            }
        },
        methods: {
            onLoadTwo () {
                ++this.pageIndexTwo
                this.finishedList()
            },
            onLoad () {
                ++this.pageIndex
                this.handleList()
            },
            // 获取待办任务列表
            handleList () {
                let parm = {
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize
                };
                api.todoList(parm).then(res => {
                    if (res.ret === 0) {
                        if (res.data.list.length > 0) {
                            res.data.list.map(item => {
                                if (item.industryCategory) {
                                    let aa = item.industryCategory
                                        .replace('[', '')
                                        .replace(']', '');
                                    let bb = aa.split(',');
                                    item.industryCategory = bb;
                                }
                            });
                        }
                        let arr = res.data.list
                        if (arr.length > 0) {
                            this.todoList = this.todoList.concat(arr)
                            if (arr.length < 10) {
                                this.finished = true
                                this.finishedText1 = '没有更多了'
                            }
                        } else {
                            this.finished = true
                            this.finishedText1 = '没有更多了'
                        }
                        this.loading = false
                    }
                });
            },
            // 获取已完成列表
            finishedList () {
                let parm = {
                    pageIndex: this.pageIndexTwo,
                    pageSize: this.pageSizeTwo
                };
                api.finisheList(parm).then(res => {
                    if (res.ret === 0) {
                        let brr = res.data.list
                        if (brr.length > 0) {
                            this.finishList = this.finishList.concat(brr)
                            if (brr.length < 10) {
                                this.finishedTwo = true
                                this.finishedText2 = '没有更多了'
                            }
                        } else {
                            this.finishedTwo = true
                            this.finishedText2 = '没有更多了'
                        }
                        this.loadingTwo = false
                    }
                });
            },
            send (msg, isImg) {
                this.$toast({
                    message: msg,
                    icon: isImg
                });
            },
            topage (item) {
                if (item.taskType == 1) {
                    this.$router.push({
                        path: '/integrity/toAudited',
                        query: {
                            id: item.id,
                            taskId: item.taskId
                        }
                    });
                } else if (item.taskType == 2) {
                    this.$router.push({
                        path: '/integrity/toBeEdited',
                        query: {
                            id: item.id,
                            taskId: item.taskId
                        }
                    });
                } else if (item.taskType == 3) {
                    this.$router.push({
                        path: '/integrity/toBeRectified',
                        query: {
                            id: item.id,
                            taskId: item.taskId
                        }
                    });
                } else if (item.taskType == 4) {
                    this.$router.push({
                        path: '/integrity/toBeRegraded',
                        query: {
                            id: item.id,
                            taskId: item.taskId
                        }
                    });
                } else if (item.taskType == 30) {
                    this.$router.push({
                        path: '/integrity/exitSupervision',
                        query: {
                            id: item.id,
                            taskId: item.taskId
                        }
                    });
                } else if (item.taskType == 31) {
                    this.$router.push({
                        path: '/integrity/examine',
                        query: {
                            id: item.id,
                            taskId: item.taskId
                        }
                    });
                } else if (item.taskType == 32) {
                    this.$router.push({
                        path: '/integrity/earlyWarning',
                        query: {
                            id: item.id,
                            taskId: item.taskId,
                            type: 'toScore'
                        }
                    });
                } else if (item.taskType == 33) {
                    this.$router.push({
                        path: '/integrity/earlyWarning',
                        query: {
                            id: item.id,
                            taskId: item.taskId,
                            type: 'warning'
                        }
                    });

                }
            },
            toFinished (item) {
                if (item.taskType == 1) {
                    let parm = {
                        taskId: item.taskId
                    };
                    api.taskInfo(parm).then(res => {
                        if (res.ret === 0) {
                            this.auditStatus = res.data.auditStatus;
                            if (this.auditStatus == 0) {
                                this.$router.push({
                                    path: '/integrity/toAudited',
                                    query: {
                                        id: item.id,
                                        taskId: item.taskId
                                    }
                                });
                            } else if (this.auditStatus == 1) {
                                this.$router.push({
                                    path: '/integrity/auditPass',
                                    query: {
                                        id: item.id,
                                        taskId: item.taskId
                                    }
                                });
                            } else if (this.auditStatus == 2) {
                                this.$router.push({
                                    path: '/integrity/auditFailed',
                                    query: {
                                        id: item.id,
                                        taskId: item.taskId
                                    }
                                });
                            }
                        }
                    });
                } else if (item.taskType == 2) {
                    this.$router.push({
                        path: '/integrity/toBeEdited',
                        query: {
                            id: item.id,
                            taskId: item.taskId
                        }
                    });
                } else if (item.taskType == 3) {
                    this.$router.push({
                        path: '/integrity/toBeRectified',
                        query: {
                            id: item.id,
                            taskId: item.taskId
                        }
                    });
                } else if (item.taskType == 4) {
                    this.$router.push({
                        path: '/integrity/toBeRegraded',
                        query: {
                            id: item.id,
                            taskId: item.taskId
                        }
                    });
                }
            }
        },
        filters: {
            filtTime (str) {
                var date = new Date(str); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-';
                var M =
                    (date.getMonth() + 1 < 10
                        ? '0' + (date.getMonth() + 1)
                        : date.getMonth() + 1) + '-';
                var D =
                    (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
                var h =
                    (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                var m =
                    (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
                    ':';
                var s =
                    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
                let strDate = Y + M + D;
                return strDate;
            }
        }
    };
</script>

<style lang="less" scoped>
.agencyCenterListBox {
  width: 100%;
  height: 100%;
  color: #333;

  .situationList {
    .situationListItem {
      width: 100%;
      margin-bottom: 16px;
      padding: 20px 16px;
      background:rgba(255,255,255,1);
      box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
      border-radius:3px;

      .situationTopBox::after {
        content: "";
        display: block;
        clear: both;
      }

      .situationTopBox {
        height: 28px;
        margin-bottom: 9px;

        .situationTitle {
          font-size: 14px;
          font-weight: bold;
          line-height: 28px;
          float: left;
          color: #333;
        }
        .situationBtn {
          width: 64px;
          height: 28px;
          font-size: 12px;
          text-align: center;
          line-height: 28px;
          color: #fff;
          background-color: #36b374;
          border-radius: 2px;
          float: right;
        }
      }

      .situationDatailList {
        > li::after {
          content: "";
          display: block;
          clear: both;
        }

        > li {
          height: 22px;

          .detailTitle {
            font-size: 14px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            line-height: 22px;
            color: #999;
            float: left;
          }
          .sitData {
            float: left;
            font-size: 14px;
            line-height: 22px;
            margin-right: 10px;
          }
          .Surplus{
            float: right;
            line-height: 22px;
            font-size: 12px;
            color: #FF8C19;
          }
          .situationData {
            float: left;
            max-width: 200px;
            font-size: 14px;
            line-height: 22px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }

  .overList {
    .overListItem {
      width: 100%;
      height: 100%;
      margin-bottom: 16px;
      padding:12px 16px 20px 16px;
      background:rgba(255,255,255,1);
      box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
      border-radius:3px;

      .overListTopBox::after {
        content: "";
        display: block;
        clear: both;
      }

      .overListTopBox {
        height: 28px;
        margin-bottom: 8px;

        .overListTitle {
          font-size: 14px;
          font-weight: bold;
          line-height: 28px;
          float: left;
          color: #333;
        }

        .overListBtn {
          width: 64px;
          height: 28px;
          font-size: 14px;
          text-align: right;
          line-height: 28px;
          color: #999999;
          border-radius: 2px;
          float: right;
        }
      }

      .overListDatailList {
        > li::after {
          content: "";
          display: block;
          clear: both;
        }

        > li {
          height: 22px;

          .overListDetailTitle {
            width:76px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space:nowrap;
            font-size: 14px;
            line-height: 22px;
            color: #999;
            float: left;
          }

          .overListData {
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 14px;
            margin-left: 72px;
            font-size: 14px;
            line-height: 22px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
}
</style>
